var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ad-agency-commission-icon',{attrs:{"ad":_vm.ad}}),_vm._v(" "),_c('ad-third-party-costs-icon',{attrs:{"ad":_vm.ad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }